import { initialize } from "./common/formvalidate/formValidate"

initialize()
